import { ThemeUICSSObject } from '@apia/theme';

const scrollbars: ThemeUICSSObject = {
  '::-webkit-scrollbar, * ::-webkit-scrollbar': {
    width: '16px',
    borderRadius: 0,
  },
  '::-webkit-scrollbar:horizontal, * ::-webkit-scrollbar:horizontal': {
    height: '8px',
  },
  '::-webkit-scrollbar-track, * ::-webkit-scrollbar-track': {
    backgroundColor: 'var(--theme-ui-colors-scrollbars-bar-backgroundColor)',
    borderLeft: '8px solid white',
  },
  '::-webkit-scrollbar-track:hover, * ::-webkit-scrollbar-track:hover': {
    backgroundColor:
      'var(--theme-ui-colors-scrollbars-bar-hover-backgroundColor)',
  },
  '::-webkit-scrollbar-track:active, * ::-webkit-scrollbar-track:active': {
    backgroundColor:
      'var(--theme-ui-colors-scrollbars-bar-active-backgroundColor)',
  },
  '::-webkit-scrollbar-thumb, * ::-webkit-scrollbar-thumb': {
    backgroundColor: 'var(--theme-ui-colors-scrollbars-bar-color)',
    borderLeft: '8px solid white',
  },
  '::-webkit-scrollbar-thumb:hover, * ::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'var(--theme-ui-colors-scrollbars-bar-hover-color)',
  },
  '::-webkit-scrollbar-thumb:active, * ::-webkit-scrollbar-thumb:active': {
    backgroundColor: 'var(--theme-ui-colors-scrollbars-bar-active-color)',
  },
  '.noScrollbar::-webkit-scrollbar': { display: 'none' },
  '.noScrollbar': { msOverflowStyle: 'none', scrollbarWidth: 'none' },
};

export default scrollbars;
